/* @jsx jsx */
/** @jsxFrag */
import React from 'react';
import { jsx } from '@emotion/react';
import { useIntl } from 'react-intl-next';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import { LatestPromptRenderer } from '../LatestPromptRenderer/LatestPromptRenderer';
import { RefinementTag } from '../RefinementTag/RefinementTag';
import { headerEditStyles, headerEditRendererStyles, headerStyles, headerWrapperStyles } from './styles';
import { messages } from './messages';
const PROMPT_CONTENT_ID = 'ai-latest-prompt-content';
export const LatestPromptHeader = ({
  prompt,
  promptADF,
  presetTitle,
  providerFactory,
  onEditPromptClick,
  schema
}) => {
  const {
    formatMessage
  } = useIntl();

  // Use renderer only if FF is on and we have user input in ADF.
  const usePromptRenderer = getBooleanFF('platform.editor.ai-lightweight-editor-prompt_f92x1') && promptADF;

  // TODO AIFOLLOWUP: We should memoize whole component as we are memoizing all the props below in useMemo.
  const header = React.useMemo(() => {
    if (usePromptRenderer) {
      return jsx(LatestPromptRenderer, {
        presetTitle: presetTitle,
        promptADF: promptADF,
        providerFactory: providerFactory,
        schema: schema
      });
    } else {
      return jsx(React.Fragment, null, presetTitle && jsx(RefinementTag, {
        label: presetTitle
      }), prompt && jsx(React.Fragment, null, prompt));
    }
  }, [usePromptRenderer, presetTitle, promptADF, providerFactory, schema, prompt]);
  if (!(prompt || presetTitle)) {
    return null;
  }
  return jsx("div", {
    "data-testid": "prompt-header"
  }, !onEditPromptClick ? jsx("div", {
    css: [headerStyles, usePromptRenderer && headerWrapperStyles],
    id: PROMPT_CONTENT_ID
  }, header) : jsx("button", {
    type: "button",
    "data-testid": "edit-prompt-button",
    onClick: onEditPromptClick,
    css: [headerStyles, headerEditStyles, usePromptRenderer && headerEditRendererStyles],
    "aria-label": formatMessage(messages.editPrompt),
    "aria-describedby": PROMPT_CONTENT_ID
  }, jsx("div", {
    css: [usePromptRenderer && headerWrapperStyles],
    id: PROMPT_CONTENT_ID
  }, header)));
};